<div fxLayout="column" class="background" fxLayoutAlign="start center">
  <div fxFlex="75">
    <!-- Título -->
    <section id="header">
      <h1 class="h1Header">REGISTROS DE TURNOS - PUNTO FIJO</h1>
    </section>

    <!-- Filtros -->
    <mat-card class="filter-card">
      <form (ngSubmit)="fetchShiftSessions()" class="filter-form">
        
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Fecha desde</mat-label>
          <input
            matInput
            [matDatepicker]="pickerFrom"
            [(ngModel)]="filterDateFrom"
            name="filterDateFrom"
          />
          <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
          <mat-datepicker #pickerFrom></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Fecha hasta</mat-label>
          <input
            matInput
            [matDatepicker]="pickerTo"
            [(ngModel)]="filterDateTo"
            name="filterDateTo"
          />
          <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Cadete</mat-label>
          <mat-select [(ngModel)]="filterCadete" name="filterCadete">
            <mat-option [value]="null">Todos los cadetes</mat-option>
            <mat-option *ngFor="let cadete of safeCadetes" [value]="cadete.cdDelivery?.toString()">
              {{ cadete.dsName || 'Sin nombre' }} ({{ cadete.dsPhone || 'Sin teléfono' }})
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Cliente</mat-label>
          <input
            matInput
            [(ngModel)]="filterClientName"
            name="filterClientName"
            placeholder="Nombre del cliente"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Estado</mat-label>
          <mat-select [(ngModel)]="filterIsFinished" name="filterIsFinished">
            <mat-option [value]="null">Todos</mat-option>
            <mat-option [value]="false">En curso</mat-option>
            <mat-option [value]="true">Finalizados</mat-option>
          </mat-select>
        </mat-form-field>

        <button
          mat-stroked-button
          color="accent"
          type="button"
          (click)="clearFilters()"
          class="filter-btn"
        >
          Limpiar
        </button>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="filter-btn"
        >
          Filtrar
        </button>
       
      </form>
    </mat-card>

    <!-- Tabla -->
    <mat-card class="mat-elevation-z0" style="margin-top: 24px">
      <table mat-table [dataSource]="safeDataSource" class="tabla">
        <ng-container matColumnDef="deliveryName">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Cadete</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ element.deliveryName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="deliveryPhone">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Teléfono</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ element.deliveryPhone }}
          </td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Cliente</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ element.client }}
          </td>
        </ng-container>

        <ng-container matColumnDef="startTime">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Hora inicio</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ formatUtcToArgentina(element.startTime) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="endTime">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Hora fin</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            <span *ngIf="element.endTime">{{ formatUtcToArgentina(element.endTime) }}</span>
            <span *ngIf="!element.endTime" class="in-progress">En curso</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            <div style="display: flex; justify-content: center; gap: 4px;">
              <button mat-icon-button color="primary" (click)="onEditShift(element)" matTooltip="Ver detalle">
                <mat-icon>visibility</mat-icon>
              </button>
              <button 
                mat-icon-button 
                color="warn" 
                *ngIf="!element.endTime"
                (click)="onEndShift(element)"
                matTooltip="Finalizar turno">
                <mat-icon>stop</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <mat-header-row *matHeaderRowDef="safeDisplayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: safeDisplayedColumns"></mat-row>
      </table>
    </mat-card>
  </div>
</div>
